import React, { useEffect, useRef, useState } from 'react'
import { Form, InputGroup } from 'react-bootstrap';

const SelectInputState = ({
    onChange,
    labelName,
    options,
    defaultValue,
    disabled,
    errorOccured,
    errorMessage
}) => {
    const [activated, setActivated] = useState(true);
    const labelRef = useRef();
    const [coverWidth, setCoverWidth] = useState(0);

    useEffect(() => {
        setCoverWidth(
            labelRef.current ? labelRef.current.getBoundingClientRect().width + 9 : 0
        );
        // if (options?.length > 0) {
        //     setActivated(true);
        // }
    }, [labelRef]);

    return (
        // <div className="mb-3">
        //     <div>
        //         <select
        //             style={{ border: '2px solid rgba(107, 107, 107, 0.12)', cursor: 'pointer' }}
        //             className="custom-select join-as-style"
        //             onChange={onChange}
        //             defaultValue={defaultValue}
        //             disabled={disabled}
        //         >
        //             <option value={''}>Select state</option>
        //             {options?.map((option) => (
        //                 <option value={option.state_name_chr}>{option.state_name_chr}</option>
        //             ))}
        //         </select>
        //     </div>
        // </div>

        <>
            <div className="col-12 mb-4">
                <InputGroup
                    className={errorOccured ? "" : "mb-2"}
                    onFocus={() => {
                        setActivated(true);
                    }}
                >
                    {" "}
                    <>
                        <Form.Group controlId="exampleForm.SelectCustom" className="col-12 border-danger">
                            {/* <Form.Label>Select Options</Form.Label> */}
                            <Form.Label
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-activated"
                                    : "textfield-label-unactivated"
                                    } textfield-label`}
                                ref={labelRef}
                                onClick={() => {
                                    setActivated(true);
                                }}>
                                <strong> {labelName}</strong>
                            </Form.Label>
                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover `}
                                style={{ width: coverWidth }}></div>
                            <Form.Control
                                className={`${errorOccured && 'border-danger'}`}
                                as="select"
                                custom
                                required
                                onChange={onChange}
                                defaultValue={defaultValue}
                                disabled={disabled}>
                                <option value={''} disabled>Select state</option>
                                {options?.map((option) => (
                                    <option value={option.state_name_chr}>
                                        {option.state_name_chr}
                                    </option>
                                ))}
                            </Form.Control>

                            <div
                                className={`${activated || defaultValue?.length > 0
                                    ? "textfield-label-cover-activated"
                                    : "textfield-label-cover-unactivated"
                                    } textfield-label-cover`}
                                style={{ width: "20px" }}></div>
                        </Form.Group>
                    </>
                    {errorOccured && (
                        <span style={{ color: "red", fontSize: "10px" }}>
                            {errorMessage}
                        </span>
                    )}
                </InputGroup>
            </div>
        </>
    )
}

export default SelectInputState